import {loginByAccount, logout, getInfo,checkLogin,queryPermission,changePassword} from 'api/login';
import {asyncRouterMap, constantRouterMap} from 'src/router';
import Cookies from 'js-cookie';

const user = {
    state: {
        account: '',
        subAccount: '',
        status: '',
        email: '',
        payment: 0,
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        permissionList: [],
        merchantAgent: '',
        setting: {
            articlePlatform: []
        }
    },

    mutations: {
        SET_UID: (state, uid) => {
            state.uid = uid;
        },
        SET_ACCOUNT: (state, account) => {
            state.account = account;
        },
        SET_SUBACCOUNT: (state, subAccount) => {
            state.subAccount = subAccount;
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles;
        },
        SET_PAYMENT: (state, payment) => {
            state.payment = payment;
        },
        LOGIN_SUCCESS: () => {

        },
        LOGOUT_USER: state => {
            state.user = '';
        },
        SET_MERCHANTAGENT: state => {
            state.merchantAgent = '';
        }
    },

    actions: {
        // 账号登录
        LoginByAccount({commit}, userInfo) {
            const account = userInfo.account.trim();
            return new Promise((resolve, reject) => {
                loginByAccount(account, userInfo.password).then(response => {
                    const data = response.data;
                    
                    Cookies.set('uid', data.uid);
                    Cookies.set('acc', data.account);
                    Cookies.set('hide_sct', data.hideSct);
                    commit('SET_UID', data.uid);
                    commit('SET_ACCOUNT', data.account);
                    commit('SET_SUBACCOUNT', data.subAccount);
                    commit('SET_PAYMENT', data.payment);
                    resolve();
                }).catch(error => {
                    console.log(error);
                    reject(error);
                });
            });
        },


        // 获取用户信息
        GetInfo({commit, state}) {
            return new Promise((resolve, reject) => {
                getInfo(state.uid).then(response => {
                    const data = response.data;
                    commit('SET_MERCHANTAGENT',data.merchantAgent);
                    commit('SET_ROLES', data.role);
                    commit('SET_UID', data.uid);
                    commit('SET_ACCOUNT', data.account);
                    commit('SET_SUBACCOUNT', data.subAccount);
                    commit('SET_PAYMENT', data.agent != undefined ? data.agent.payment: 0);
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },

        // 第三方验证登录
        LoginByThirdparty({commit, state}, code) {
            return new Promise((resolve, reject) => {
                commit('SET_CODE', code);
                loginByThirdparty(state.status, state.email, state.code, state.auth_type).then(response => {
                    commit('SET_ACCOUNT', response.data.token);
                    resolve();
                }).catch(error => {
                    reject(error);
                });
            });
        },


        // 登出
        LogOut({commit, state}) {
            return new Promise((resolve, reject) => {
                logout().then(() => {
                    Cookies.remove('uid');
                    commit('SET_UID', '');
                    resolve();
                }).catch(error => {
                    reject(error);
                });
            });
        },

        // 前端 登出
        FedLogOut({commit}) {
            return new Promise(resolve => {
                commit('SET_ACCOUNT', '');
                Cookies.remove('uid');
                // alert("has logout");
                resolve();
            });
        },

        // 动态修改权限
        ChangeRole({commit}, role) {
            return new Promise(resolve => {
                commit('SET_ROLES', [role]);
                commit('SET_ACCOUNT', role);
                Cookies.set('Admin-Token', role);
                resolve();
            })
        },
        //是否登陆
        checkLogin() {
            return new Promise((resolve, reject) => {
                checkLogin().then(response => {
                    return true;
                }).catch(error => {
                   return false;
                });
            });
        },
        // 获取权限列表
        getPermission({commit}, account) {
            return new Promise((resolve, reject) => {
                queryPermission(account).then(res => {
                    //调用权限匹配的方法
                    var privileges = res.data;
                    resolve(privileges);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        // 获取权限列表
        changePassword({commit}, params) {
            return new Promise((resolve, reject) => {
                changePassword(params).then(res => {
                    var privileges = res.data;
                    resolve(privileges);
                }).catch(error => {
                    reject(error);
                });
            });
        }
    }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js